import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

const BackDropComponent = ({ open }) => {
  return (
    <Backdrop
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        color: "#fff",
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default BackDropComponent;
